import type { UUID } from "@/core/types";

import { useCosignatureSupervisors } from "../api/queries/useCosignatureSupervisors";

export function useMatchSupervisor(id?: UUID) {
  const { data: supervisor, isLoading } = useCosignatureSupervisors({
    enabled: !!id,
    select: (supervisors) => supervisors.find((s) => s.id === id),
  });

  return { isLoading, supervisor };
}
